import React, { useEffect, useState } from 'react';

import Button from '@material-ui/core/Button';

import * as Yup from 'yup';

import FormControl from '@material-ui/core/FormControl';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';

import BobClientSelector from '../components/BobClientSelector';
import BobSiteSelector from '../components/BobSiteSelector';
import BobEntitySelector from './BobEntitySelector';

import { useFormik } from 'formik';

import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import BobConfirmButton from './BobConfirmButton';
import BobCancelButton from './BobCancelButton';

import * as K2ACoreActions from '../actions/k2aCoreActions';

import * as classes from './BobFilterComponent.module.css';

const ValidationSchema = Yup.object().shape({
    client: Yup.string()
        .nullable()
        .required()
});

const BobRuleFilterComponent = ({
    activeNavCompany,
    activeFilters,
    companyInfo,
    fetchClients,
    label,
    data,
    filterType,
    isFromRuleDebugger,
    isFromLegacyRuleDebugger,
    isFromRulesTable,
    setClearFilters,
    setFilters,
    style,
    showStatusFilter,
    ...props
}) => {
    const [clientList, setClientList] = useState([]);
    const [filterOpen, setFilterOpen] = useState(false);
    const [hasFilter, setHasFilter] = useState(false);

    useEffect(() => {
        const init = async () => {
            const list = await fetchClients(activeNavCompany.id, { limit: 1000 });
            setClientList(list);
        };

        if (activeNavCompany && activeNavCompany.id) init();
    }, [activeNavCompany]);

    useEffect(() => {
        const init = async () => {
            const list = await fetchClients(companyInfo.companyId, { limit: 1000 });
            setClientList(list);
        };

        if (companyInfo && companyInfo.companyId) init();
    }, [companyInfo]);

    const handleToggle = () => {
        setFilterOpen(!filterOpen);
    };

    const resetFilter = () => {
        setFilters({
            clientId:   '',
            clientName: '',
            siteId:     '',
            siteName:   '',
            entityId:   '',
            entityName: ''
        });
        
        formik.setFieldValue('client', '', false);
        formik.setFieldValue('site', '', false);
        formik.setFieldValue('entity', '', false);

        setHasFilter(false);
        setFilterOpen(false);
        
        if (isFromRulesTable) {
            setClearFilters(true);
        }
    };

    const handleClickAway = () => {
        setFilterOpen(false);
    };

    const handleFilterApply = (values) => {
        const filter = {
            clientId:   values.client.id,
            clientName: values.client.name,
            siteId:     '',
            siteName:   '',
            entityId:   '',
            entityName: ''
        };

        if (values.site) {
            filter.siteId = values.site.id;
            filter.siteName = values.site.name;
        }

        if (values.entity) {
            filter.entityId = values.entity.id;
            filter.entityName = values.entity.name;
        }

        setHasFilter(true);
        setFilters(filter);
        setFilterOpen(false);
    };
    
    const formik = useFormik({
        initialValues: {
            client: '',
            site:   '',
            entity: ''
        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            handleFilterApply(values);
        }
    });

    const handleClientChange = (event, value) => {
        if (value) {
            formik.setFieldValue('client', value, false);
        } else {
            formik.setFieldValue('client', '', false);
        }
        formik.setFieldValue('site', '', false);
        formik.setFieldValue('entity', '', false);
    };

    const handleSiteChange = async (event, value) => {
        if (value) {
            formik.setFieldValue('site', value, false);
        } else {
            formik.setFieldValue('site', '', false);
        }
        formik.setFieldValue('entity', '', false);
    };

    const handleEntityChange = async (event, value) => {
        if (value) {
            formik.setFieldValue('entity', value, false);
        } else {
            formik.setFieldValue('entity', '', false);
        }
    };

    return (
        <ClickAwayListener
            onClickAway={handleClickAway}
        >
            <span>
                <Button
                    className={classes.FilterButton}
                    onClick={handleToggle}
                >
                    <i className="fas fa-filter" aria-hidden="true" />
                </Button>
                {
                    filterOpen ? 
                        <Paper className={classes.BobFilterComponentMenu} style={style}>
                            <div className={classes.SelectContainer}>
                                <FormControl variant="outlined" size="small" className={classes.SelectItem}>
                                    <BobClientSelector
                                        companyId={isFromLegacyRuleDebugger ? companyInfo.companyId : activeNavCompany.id}
                                        value={formik.values.client}
                                        errors={formik.errors.client}
                                        touched={formik.touched.client}
                                        handleChange={handleClientChange}
                                        label="Select Client"
                                        clientList={clientList}
                                        isFromRuleDebugger={isFromRuleDebugger}
                                        isFromLegacyRuleDebugger={isFromLegacyRuleDebugger}
                                        required
                                    />
                                </FormControl>
                                <FormControl variant="outlined" size="small" className={classes.SelectItem}>
                                    <BobSiteSelector
                                        companyId={isFromLegacyRuleDebugger ? companyInfo.companyId : activeNavCompany.id}
                                        clientId={formik.values.client}
                                        errors={formik.errors.site}
                                        touched={formik.touched.site}
                                        value={formik.values.site}
                                        handleChange={handleSiteChange}
                                        label="Select Site"
                                        isFromRuleDebugger={isFromRuleDebugger}
                                        disabled={isEmpty(formik.values.client) ? true : false}
                                    />
                                </FormControl>
                                <FormControl variant="outlined" size="small" className={classes.SelectItem}>
                                    <BobEntitySelector
                                        companyId={isFromLegacyRuleDebugger ? companyInfo.companyId : activeNavCompany.id}
                                        clientId={formik.values.client}
                                        siteId={formik.values.site}
                                        errors={formik.errors.entity}
                                        touched={formik.touched.entity}
                                        value={formik.values.entity}
                                        handleChange={handleEntityChange}
                                        label="Select Entity"
                                        isFromRuleDebugger={isFromRuleDebugger}
                                        disabled={isEmpty(formik.values.site) ? true : false}
                                    />
                                </FormControl>
                            </div>
                            <div>
                                {
                                    hasFilter ? 
                                        <i onClick={resetFilter} className={`fas fa-undo fa-lg ${classes.FilterIcon}`} aria-hidden="true" />
                                        :
                                        null
                                }
                                <BobCancelButton
                                    className={classes.Buttons}
                                    label={'Cancel'}
                                    cancel={handleToggle}
                                />
                                <BobConfirmButton
                                    className={classes.Buttons}
                                    label={'OK'}
                                    onClick={formik.handleSubmit}
                                />
                            </div>
                        </Paper>
                        :
                        null
                }
            </span>
        </ClickAwayListener>
    );
};


const mapDispatchToProps = {
    ...K2ACoreActions
};

export default connect(null, mapDispatchToProps)(BobRuleFilterComponent);
